module.exports = __webpack_public_path__ + "static/img/uzaviraci_ventil_prirubovy.47a7547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uzaviraci_ventil_prirubovy.png
// module id = iRb0
// module chunks = 1